import { BasicsState } from './State'
import {
  SET_RESPONSE,
  SET_SCHOOL_RESPONSE,
  SET_RESPONSES,
  ADD_SCHOOL,
  SET_SCHOOL_SEARCH_RESULT,
  SET_IS_SEARCHING_SCHOOL,
  BasicsAction
} from './Actions'

function moreAboutMeReducer(state: BasicsState, action: BasicsAction): BasicsState {
  switch (action.type) {
    case SET_RESPONSE:
      return Object.assign({}, state, {
        user: {
          ...state.user,
          [action.payload.questionKey]: action.payload.response
        }
      })
    case SET_SCHOOL_RESPONSE:
      const { index, schoolUpdates } = action.payload
      const school = state.user.schools[index]
      state.user.schools[index] = { ...school, ...schoolUpdates }
      return Object.assign({}, state)
    case SET_RESPONSES:
      return Object.assign({}, state, {
        user: {
          ...state.user,
          ...action.payload
        }
      })
    case ADD_SCHOOL:
      return Object.assign({}, state, {
        user: {
          ...state.user,
          schools: [...state.user.schools, {}]
        }
      })
    case SET_SCHOOL_SEARCH_RESULT:
      return Object.assign({}, state, {
        schools: {
          ...state.schools,
          options: action.payload
        }
      })
    case SET_IS_SEARCHING_SCHOOL:
      return Object.assign({}, state, {
        schools: {
          ...state.schools,
          isSearching: action.payload
        }
      })
    default:
      return state
  }
}

export default moreAboutMeReducer
